export enum CustomerPermissions {
  ALL = "Travel:Customers:*",
  READ = "Travel:Customers:Read",
  WRITE = "Travel:Customers:Write",
}

export function hasCustomerAccess(userPermissions: string[]): boolean {
  return userPermissions.some((p) =>
    [CustomerPermissions.READ, CustomerPermissions.ALL, "*"].includes(p)
  );
}
